import React from 'react';
import styled, { css } from 'styled-components';
/* import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters'; */
import colors from '../../../vars/colors';

export const Text = styled.div`
    color: ${colors['black']};
    font-size: 20px;
    font-family: 'OneDot', sans-serif;
    line-height: 1.75;
    font-weight: 300;
`;



// WEBPACK FOOTER //
// ./src/components/modules/TextBlock/styled-components.js